import { useEffect, useState } from 'react';
import { storage } from '../../utils/platform';
import { useCurrentRestaurant } from '../contexts/CurrentRestaurantContext';
import { API_BASE } from '../../config/api';

export function useDashboardData() {
  // Vague 10 : refetch automatique quand l'utilisateur switche de restaurant.
  const { currentRestaurantId } = useCurrentRestaurant();
  const [data, setData] = useState({
    user: null,
    restaurant: null,
    stats: null,
    objectif_avis: 15,
    avis_generes_revyo: 0,
    progression_pilote: 0,
    google_error: null,
    googleConnected: false,
    loading: true,
    error: null,
  });

  useEffect(() => {
    let cancelled = false;
    setData(d => ({ ...d, loading: true }));

    (async () => {
      try {
        const token = await storage.get('token');
        if (!token) {
          if (!cancelled) setData(d => ({ ...d, loading: false, error: 'NO_TOKEN' }));
          return;
        }

        const headers = {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          ...(currentRestaurantId ? { 'X-Restaurant-Id': currentRestaurantId } : {}),
        };

        const [dashboardRes, gmbRes] = await Promise.all([
          fetch(`${API_BASE}/api/dashboard`, { headers }),
          fetch(`${API_BASE}/api/gmb/status`, { headers }).catch(() => null),
        ]);

        if (!dashboardRes.ok) {
          throw new Error(`Dashboard API ${dashboardRes.status}`);
        }

        const dashboardData = await dashboardRes.json();
        const gmbData = gmbRes && gmbRes.ok ? await gmbRes.json() : { connected: false };

        if (cancelled) return;

        setData({
          user: dashboardData.user,
          restaurant: dashboardData.restaurant,
          stats: dashboardData.stats,
          objectif_avis: dashboardData.objectif_avis ?? 15,
          avis_generes_revyo: dashboardData.avis_generes_revyo ?? 0,
          progression_pilote: dashboardData.progression_pilote ?? 0,
          google_error: dashboardData.google_error,
          googleConnected: gmbData.connected ?? false,
          loading: false,
          error: null,
        });
      } catch (err) {
        console.error('[useDashboardData]', err);
        if (!cancelled) setData(d => ({ ...d, loading: false, error: err.message }));
      }
    })();

    return () => { cancelled = true; };
  }, [currentRestaurantId]);

  return data;
}
